import * as SuperAdmin from 'constants/super-admin';

interface SuffixSortState {
  columnName: string;
  desc: boolean;
}

// Action carries sort/selection fields; typed minimally at the reducer boundary.
interface SuffixSortAction {
  type: string;
  columnName?: string;
  desc?: boolean;
}

const defaultState: SuffixSortState = {
  columnName: 'siteAdminCostCenter',
  desc: false,
};

export const SuffixSortReducer = (
  state: SuffixSortState = defaultState,
  action: SuffixSortAction,
): SuffixSortState => {
  switch (action.type) {
    case SuperAdmin.SORT_ACTION_TYPES.SORT_SUFFIX:
      return {
        columnName: action.columnName as string,
        // Toggle current `desc` if toggling current column, defer to incoming  `desc` if selecting
        // new column:
        desc: state.columnName === action.columnName ? !state.desc : (action.desc as boolean),
      };
    // When changing tool, reset sort state
    case SuperAdmin.SELECTOR_ACTION_TYPES.SELECT_TOOL:
      return defaultState;
    default:
      return state;
  }
};
